import { organisationConstants } from '../../../_constants';

const initialState = {
    organisation_fitments_list_loading: true,
    organisation_fitments_list: [],
    organisation_fitments_list_error: false, 
    organisation_fitments_list_error_data: {}
};

export function getOrganistionFitmentsList(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_GET_ORGANISATION_FITMENTS_LIST:
            return {
                organisation_fitments_list_loading: true,
                organisation_fitments_list: [],
                organisation_fitments_list_error: false, 
                organisation_fitments_list_error_data: {}
            };
        case organisationConstants.RECEIVE_GET_ORGANISATION_FITMENTS_LIST:
            return {
                organisation_fitments_list_loading: false,
                organisation_fitments_list: action.organisation_fitments,
                organisation_fitments_list_error: false,
                organisation_fitments_list_error_data: {}
            };
        case organisationConstants.GET_ORGANISATION_FITMENTS_LIST_ERROR:
            return {
                organisation_fitments_list_loading: false,
                organisation_fitments_list: [],
                organisation_fitments_list_error: true,
                organisation_fitments_list_error_data: action.error
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/roleFitmentReport/getOrganisationFitmentList.reducer.js